import { createSvgComponent } from "../../icon/createSvgComponent";
import Chatbubble from "@core/__generated__/icon/figma/chatbubble.svg";
export default createSvgComponent(Chatbubble);